import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35ca4cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "div-background" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "div-text" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 2 }

import { computed } from "vue";
import { parseService } from "@/services/parse.service";

interface Props {
  background?: string;
  height?: string;
  title?: string;
  subtitle?: string;
  hideLogo?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    background: { default: "https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80" },
    height: { default: "66vh" },
    title: { default: "Simple Header" },
    subtitle: { default: undefined },
    hideLogo: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { background: string, height: string, title: string, subtitle: string, hideLogo: boolean }

const isTopoFire = computed(() => {
  return parseService.isTopoFireApp();
});



const heightCSS = computed((): string => {
  return `height: ${props.height}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "parent",
    style: _normalizeStyle({ height: `${__props.height}` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "banner-image",
        src: __props.background,
        alt: "Banner Image"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(isTopoFire) && !__props.hideLogo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "logo-image",
            src: require('@/assets/images/img/TopoFire-60-Rounded@3x.png'),
            alt: "Logo Image"
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _hoisted_5,
      (!_unref(isTopoFire) && !__props.hideLogo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "logo-image",
            src: require('@/assets/images/img/Icon-60-Rounded@3x.png'),
            alt: "Logo Image"
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("h1", null, [
        _createElementVNode("span", null, _toDisplayString(__props.title), 1)
      ]),
      (__props.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(__props.subtitle), 1)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "under-title")
    ])
  ], 4))
}
}

})